import { useGetUserQuery } from 'src/common/slices';

export const useUsername = (): string | undefined => {
  const { data: userData } = useGetUserQuery();
  return userData?.data?.user?.username;
};
